// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261405/js/" + chunkId + "." + {"44":"80758491","225":"ce437e4e","481":"77fb1010","486":"0def8dee","770":"7a406991"}[chunkId] + ".0.4312232299523505.chunk.js";
};